import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=c6f0495a&scoped=true"
import script from "./AddProductModal.vue?vue&type=script&lang=js"
export * from "./AddProductModal.vue?vue&type=script&lang=js"
import style0 from "./AddProductModal.vue?vue&type=style&index=0&id=c6f0495a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f0495a",
  null
  
)

export default component.exports